module.exports = __webpack_public_path__ + "img/grey_053.309db090.png";